// Multilingual content for ZEMI SWISS GmbH (DE / FR / IT / EN)

export const LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

export const TRANSLATIONS = {
  de: {
    nav: {
      home: "Startseite",
      services: "Dienstleistungen",
      quote: "Offerte anfragen",
      contact: "Kontakt",
      about: "Über uns",
    },
    hero: {
      eyebrow: "Schweizer Qualität · Seit 2020",
      title: "ZEMI SWISS GmbH",
      subtitle: "Transport & Reinigung in der ganzen Schweiz",
      description:
        "Ihr zuverlässiger Partner für professionelle Transport- und Reinigungsdienstleistungen. Schnell, sauber und kundenorientiert.",
      ctaPrimary: "Kostenlose Offerte anfordern",
      ctaSecondary: "Jetzt anrufen",
      scrollHint: "Mehr entdecken",
    },
    marquee: [
      "Transport Herisau",
      "Reinigung Schweiz",
      "Möbeltransport",
      "Endreinigung",
      "Büroreinigung",
      "Kurierfahrten",
      "Wohnungsreinigung",
      "Gebäudereinigung",
    ],
    about: {
      eyebrow: "Über uns",
      title: "Zuverlässigkeit, Qualität & Kundenzufriedenheit.",
      text:
        "Die ZEMI SWISS GmbH steht für Zuverlässigkeit, Qualität und Kundenzufriedenheit. Wir bieten professionelle Transport- und Reinigungsdienstleistungen für Privatpersonen, Unternehmen und Verwaltungen. Unser Ziel ist eine unkomplizierte, termingerechte und saubere Ausführung aller Aufträge.",
      stats: [
        { value: "100%", label: "Kundenorientiert" },
        { value: "24/7", label: "Erreichbar" },
        { value: "CH", label: "Ganze Schweiz" },
      ],
    },
    services: {
      eyebrow: "Dienstleistungen",
      title: "Zwei Disziplinen. Ein Standard: Schweizer Präzision.",
      transport: {
        title: "Transport",
        description:
          "Vom Möbel- bis zum Geschäftstransport: schnell, sicher und termingenau in der ganzen Schweiz.",
        items: [
          "Möbeltransporte",
          "Kleintransporte",
          "Kurierfahrten",
          "Lieferdienste",
          "Geschäftstransporte",
        ],
      },
      cleaning: {
        title: "Reinigung",
        description:
          "Glänzende Ergebnisse für Privat und Gewerbe – mit professioneller Endreinigungsgarantie.",
        items: [
          "Wohnungsreinigung",
          "Endreinigung",
          "Büroreinigung",
          "Unterhaltsreinigung",
          "Gebäudereinigung",
        ],
      },
    },
    why: {
      eyebrow: "Warum ZEMI SWISS",
      title: "Fünf Gründe, warum Kunden uns vertrauen.",
      items: [
        {
          title: "Zuverlässig & pünktlich",
          desc: "Termintreue ist für uns Ehrensache – wie es sich für einen Schweizer Betrieb gehört.",
        },
        {
          title: "Faire & transparente Preise",
          desc: "Klare Offerten ohne versteckte Kosten. Sie wissen genau, was Sie bezahlen.",
        },
        {
          title: "Schnelle Offerten",
          desc: "Antwort innert 24 Stunden – meistens noch am selben Tag.",
        },
        {
          title: "Persönlicher Kundenservice",
          desc: "Direkter Kontakt zum Inhaber. Keine Warteschlangen, keine Callcenter.",
        },
        {
          title: "Flexible Terminvereinbarung",
          desc: "Wochenenden, Abende oder kurzfristig – wir richten uns nach Ihrem Zeitplan.",
        },
      ],
    },
    quote: {
      eyebrow: "Offerte anfragen",
      title: "In 60 Sekunden zur kostenlosen Offerte.",
      description:
        "Beschreiben Sie kurz Ihr Anliegen – wir melden uns innert 24 Stunden mit einem unverbindlichen Angebot zurück.",
      fields: {
        name: "Name",
        phone: "Telefon",
        email: "E-Mail",
        service: "Dienstleistung",
        message: "Nachricht",
        servicePlaceholder: "Bitte wählen",
        servicesOptions: {
          transport: "Transport",
          reinigung: "Reinigung",
          beides: "Transport & Reinigung",
          andere: "Andere",
        },
        messagePlaceholder: "Erzählen Sie uns kurz, worum es geht…",
      },
      submit: "Offerte anfordern",
      submitting: "Wird gesendet…",
      success: "Vielen Dank für Ihre Anfrage. Wir werden uns schnellstmöglich bei Ihnen melden.",
      error: "Die Anfrage konnte nicht gesendet werden. Bitte rufen Sie uns direkt an.",
      privacy: "Mit dem Absenden stimmen Sie unserer Datenschutzerklärung zu.",
    },
    contact: {
      eyebrow: "Kontakt",
      title: "Bereit für den nächsten Auftrag.",
      phone: "Telefon",
      email: "E-Mail",
      address: "Adresse",
      hours: "Öffnungszeiten",
      hoursValue: "Mo–Sa · 07:00–20:00",
      mapTitle: "Standort Herisau",
    },
    footer: {
      tagline: "Transport & Reinigung",
      sections: {
        company: "Unternehmen",
        services: "Dienstleistungen",
        legal: "Rechtliches",
      },
      links: {
        about: "Über uns",
        contact: "Kontakt",
        quote: "Offerte",
        imprint: "Impressum",
        privacy: "Datenschutz",
      },
      copyright: "© 2025 ZEMI SWISS GmbH · Alle Rechte vorbehalten.",
    },
    legal: {
      imprint: {
        title: "Impressum",
        intro: "Angaben gemäss Schweizer Recht (Art. 322 OR / Internetauftritt).",
        sections: [
          { h: "Firma", b: "ZEMI SWISS GmbH" },
          { h: "Adresse", b: "Langenlenstrasse 10b, 9100 Herisau, Schweiz" },
          { h: "Kontakt", b: "+41 78 321 52 49 · +41 78 258 42 61 · info@zemiswiss.ch" },
          {
            h: "Haftungsausschluss",
            b: "Die Inhalte dieser Website wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.",
          },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        intro:
          "Diese Datenschutzerklärung informiert Sie über die Erhebung und Verarbeitung Ihrer Daten gemäss dem Schweizer Datenschutzgesetz (DSG).",
        sections: [
          {
            h: "Verantwortliche Stelle",
            b: "ZEMI SWISS GmbH, Langenlenstrasse 10b, 9100 Herisau, info@zemiswiss.ch",
          },
          {
            h: "Erhobene Daten",
            b: "Bei einer Anfrage über unser Formular erheben wir Ihren Namen, Telefonnummer, E-Mail und Ihre Nachricht – ausschliesslich zur Bearbeitung Ihrer Anfrage.",
          },
          {
            h: "Weitergabe an Dritte",
            b: "Eine Weitergabe an Dritte erfolgt nicht, ausser für die technische Zustellung (E-Mail-Versand via Resend).",
          },
          {
            h: "Ihre Rechte",
            b: "Sie haben jederzeit das Recht auf Auskunft, Berichtigung und Löschung Ihrer Daten. Kontakt: info@zemiswiss.ch.",
          },
        ],
      },
      back: "Zurück zur Startseite",
    },
  },

  fr: {
    nav: { home: "Accueil", services: "Services", quote: "Demander un devis", contact: "Contact", about: "À propos" },
    hero: {
      eyebrow: "Qualité Suisse · Depuis 2020",
      title: "ZEMI SWISS GmbH",
      subtitle: "Transport & Nettoyage dans toute la Suisse",
      description:
        "Votre partenaire de confiance pour des services de transport et de nettoyage professionnels. Rapide, propre et orienté client.",
      ctaPrimary: "Demander un devis gratuit",
      ctaSecondary: "Appeler maintenant",
      scrollHint: "Découvrir",
    },
    marquee: ["Transport Herisau", "Nettoyage Suisse", "Déménagement", "Nettoyage final", "Nettoyage de bureaux", "Coursiers", "Nettoyage d'appartements", "Nettoyage de bâtiments"],
    about: {
      eyebrow: "À propos",
      title: "Fiabilité, qualité & satisfaction client.",
      text:
        "ZEMI SWISS GmbH représente fiabilité, qualité et satisfaction client. Nous proposons des services professionnels de transport et de nettoyage aux particuliers, entreprises et administrations. Notre objectif : une exécution simple, ponctuelle et impeccable de chaque mandat.",
      stats: [
        { value: "100%", label: "Orienté client" },
        { value: "24/7", label: "Joignable" },
        { value: "CH", label: "Toute la Suisse" },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Deux métiers. Un standard : la précision suisse.",
      transport: {
        title: "Transport",
        description:
          "Du déménagement au transport professionnel : rapide, sûr et à l'heure dans toute la Suisse.",
        items: ["Déménagements", "Petits transports", "Coursiers", "Livraisons", "Transports professionnels"],
      },
      cleaning: {
        title: "Nettoyage",
        description:
          "Des résultats éclatants pour les particuliers et les professionnels – avec garantie de remise des clés.",
        items: ["Nettoyage d'appartements", "Nettoyage final", "Nettoyage de bureaux", "Entretien", "Nettoyage de bâtiments"],
      },
    },
    why: {
      eyebrow: "Pourquoi ZEMI SWISS",
      title: "Cinq raisons pour lesquelles nos clients nous font confiance.",
      items: [
        { title: "Fiable & ponctuel", desc: "Respecter les délais est une question d'honneur, à la suisse." },
        { title: "Prix justes & transparents", desc: "Des devis clairs, sans coûts cachés." },
        { title: "Devis rapides", desc: "Réponse sous 24 heures – souvent le jour même." },
        { title: "Service personnalisé", desc: "Contact direct avec le propriétaire. Pas de centre d'appels." },
        { title: "Rendez-vous flexibles", desc: "Week-ends, soirées ou court terme – nous nous adaptons." },
      ],
    },
    quote: {
      eyebrow: "Demander un devis",
      title: "Votre devis gratuit en 60 secondes.",
      description:
        "Décrivez brièvement votre demande – nous revenons vers vous sous 24 heures avec une offre sans engagement.",
      fields: {
        name: "Nom", phone: "Téléphone", email: "E-mail", service: "Service", message: "Message",
        servicePlaceholder: "Veuillez choisir",
        servicesOptions: { transport: "Transport", reinigung: "Nettoyage", beides: "Transport & Nettoyage", andere: "Autre" },
        messagePlaceholder: "Dites-nous brièvement de quoi il s'agit…",
      },
      submit: "Demander un devis",
      submitting: "Envoi en cours…",
      success: "Merci pour votre demande. Nous vous recontacterons dans les plus brefs délais.",
      error: "L'envoi a échoué. Veuillez nous appeler directement.",
      privacy: "En soumettant, vous acceptez notre politique de confidentialité.",
    },
    contact: {
      eyebrow: "Contact", title: "Prêts pour votre prochain mandat.",
      phone: "Téléphone", email: "E-mail", address: "Adresse",
      hours: "Heures d'ouverture", hoursValue: "Lu–Sa · 07:00–20:00",
      mapTitle: "Emplacement Herisau",
    },
    footer: {
      tagline: "Transport & Nettoyage",
      sections: { company: "Entreprise", services: "Services", legal: "Mentions légales" },
      links: { about: "À propos", contact: "Contact", quote: "Devis", imprint: "Mentions légales", privacy: "Confidentialité" },
      copyright: "© 2025 ZEMI SWISS GmbH · Tous droits réservés.",
    },
    legal: {
      imprint: { title: "Mentions légales", intro: "Informations selon le droit suisse.", sections: [
        { h: "Société", b: "ZEMI SWISS GmbH" },
        { h: "Adresse", b: "Langenlenstrasse 10b, 9100 Herisau, Suisse" },
        { h: "Contact", b: "+41 78 321 52 49 · +41 78 258 42 61 · info@zemiswiss.ch" },
        { h: "Avertissement", b: "Le contenu de ce site a été rédigé avec le plus grand soin, sans garantie d'exactitude." },
      ]},
      privacy: { title: "Politique de confidentialité", intro: "Conformément à la loi suisse (LPD).", sections: [
        { h: "Responsable", b: "ZEMI SWISS GmbH, Langenlenstrasse 10b, 9100 Herisau, info@zemiswiss.ch" },
        { h: "Données collectées", b: "Lors d'une demande, nous collectons votre nom, téléphone, e-mail et message – uniquement pour traiter votre demande." },
        { h: "Tiers", b: "Aucun transfert à des tiers, sauf pour la transmission technique (Resend)." },
        { h: "Vos droits", b: "Vous avez le droit d'accéder, corriger et supprimer vos données. Contact : info@zemiswiss.ch." },
      ]},
      back: "Retour à l'accueil",
    },
  },

  it: {
    nav: { home: "Home", services: "Servizi", quote: "Richiedi preventivo", contact: "Contatti", about: "Chi siamo" },
    hero: {
      eyebrow: "Qualità Svizzera · Dal 2020",
      title: "ZEMI SWISS GmbH",
      subtitle: "Trasporto & Pulizia in tutta la Svizzera",
      description:
        "Il vostro partner affidabile per servizi di trasporto e pulizia professionali. Veloce, pulito e orientato al cliente.",
      ctaPrimary: "Richiedi preventivo gratuito",
      ctaSecondary: "Chiama ora",
      scrollHint: "Scopri di più",
    },
    marquee: ["Trasporto Herisau", "Pulizia Svizzera", "Traslochi", "Pulizia finale", "Pulizia uffici", "Corrieri", "Pulizia appartamenti", "Pulizia edifici"],
    about: {
      eyebrow: "Chi siamo",
      title: "Affidabilità, qualità e soddisfazione del cliente.",
      text:
        "ZEMI SWISS GmbH è sinonimo di affidabilità, qualità e soddisfazione del cliente. Offriamo servizi professionali di trasporto e pulizia a privati, aziende e amministrazioni. Il nostro obiettivo: un'esecuzione semplice, puntuale e impeccabile.",
      stats: [
        { value: "100%", label: "Orientati al cliente" },
        { value: "24/7", label: "Raggiungibili" },
        { value: "CH", label: "Tutta la Svizzera" },
      ],
    },
    services: {
      eyebrow: "Servizi",
      title: "Due discipline. Uno standard: la precisione svizzera.",
      transport: {
        title: "Trasporto",
        description: "Dal trasloco al trasporto aziendale: rapido, sicuro e puntuale in tutta la Svizzera.",
        items: ["Traslochi", "Piccoli trasporti", "Corrieri", "Consegne", "Trasporti aziendali"],
      },
      cleaning: {
        title: "Pulizia",
        description: "Risultati brillanti per privati e aziende – con garanzia di pulizia finale.",
        items: ["Pulizia appartamenti", "Pulizia finale", "Pulizia uffici", "Manutenzione", "Pulizia edifici"],
      },
    },
    why: {
      eyebrow: "Perché ZEMI SWISS",
      title: "Cinque motivi per cui i clienti ci scelgono.",
      items: [
        { title: "Affidabili & puntuali", desc: "Il rispetto delle scadenze è per noi questione d'onore." },
        { title: "Prezzi equi & trasparenti", desc: "Preventivi chiari, senza costi nascosti." },
        { title: "Preventivi rapidi", desc: "Risposta entro 24 ore – spesso lo stesso giorno." },
        { title: "Servizio personale", desc: "Contatto diretto con il titolare. Niente call center." },
        { title: "Appuntamenti flessibili", desc: "Weekend, sere o a breve termine – ci adattiamo a voi." },
      ],
    },
    quote: {
      eyebrow: "Richiedi preventivo",
      title: "Preventivo gratuito in 60 secondi.",
      description: "Descrivete brevemente la vostra richiesta – vi ricontatteremo entro 24 ore con un'offerta senza impegno.",
      fields: {
        name: "Nome", phone: "Telefono", email: "E-mail", service: "Servizio", message: "Messaggio",
        servicePlaceholder: "Si prega di scegliere",
        servicesOptions: { transport: "Trasporto", reinigung: "Pulizia", beides: "Trasporto & Pulizia", andere: "Altro" },
        messagePlaceholder: "Ditecene brevemente di più…",
      },
      submit: "Richiedi preventivo",
      submitting: "Invio in corso…",
      success: "Grazie per la vostra richiesta. Vi ricontatteremo al più presto.",
      error: "Invio fallito. Vi preghiamo di chiamarci direttamente.",
      privacy: "Inviando, accettate la nostra informativa sulla privacy.",
    },
    contact: {
      eyebrow: "Contatti", title: "Pronti per il prossimo incarico.",
      phone: "Telefono", email: "E-mail", address: "Indirizzo",
      hours: "Orari", hoursValue: "Lu–Sa · 07:00–20:00",
      mapTitle: "Sede Herisau",
    },
    footer: {
      tagline: "Trasporto & Pulizia",
      sections: { company: "Azienda", services: "Servizi", legal: "Note legali" },
      links: { about: "Chi siamo", contact: "Contatti", quote: "Preventivo", imprint: "Note legali", privacy: "Privacy" },
      copyright: "© 2025 ZEMI SWISS GmbH · Tutti i diritti riservati.",
    },
    legal: {
      imprint: { title: "Note legali", intro: "Informazioni secondo il diritto svizzero.", sections: [
        { h: "Azienda", b: "ZEMI SWISS GmbH" },
        { h: "Indirizzo", b: "Langenlenstrasse 10b, 9100 Herisau, Svizzera" },
        { h: "Contatti", b: "+41 78 321 52 49 · +41 78 258 42 61 · info@zemiswiss.ch" },
        { h: "Esclusione di responsabilità", b: "I contenuti sono stati redatti con la massima cura, senza garanzia di esattezza." },
      ]},
      privacy: { title: "Informativa sulla privacy", intro: "Conformemente alla legge svizzera (LPD).", sections: [
        { h: "Titolare", b: "ZEMI SWISS GmbH, Langenlenstrasse 10b, 9100 Herisau, info@zemiswiss.ch" },
        { h: "Dati raccolti", b: "Nome, telefono, e-mail e messaggio – solo per gestire la vostra richiesta." },
        { h: "Terzi", b: "Nessun trasferimento a terzi, eccetto la trasmissione tecnica (Resend)." },
        { h: "I vostri diritti", b: "Avete diritto di accesso, rettifica e cancellazione. Contatto: info@zemiswiss.ch." },
      ]},
      back: "Torna alla home",
    },
  },

  en: {
    nav: { home: "Home", services: "Services", quote: "Request a quote", contact: "Contact", about: "About" },
    hero: {
      eyebrow: "Swiss Quality · Since 2020",
      title: "ZEMI SWISS GmbH",
      subtitle: "Transport & Cleaning across Switzerland",
      description:
        "Your reliable partner for professional transport and cleaning services. Fast, clean and customer-focused.",
      ctaPrimary: "Request a free quote",
      ctaSecondary: "Call now",
      scrollHint: "Discover more",
    },
    marquee: ["Transport Herisau", "Cleaning Switzerland", "Furniture moving", "Move-out cleaning", "Office cleaning", "Courier", "Apartment cleaning", "Building cleaning"],
    about: {
      eyebrow: "About us",
      title: "Reliability, quality & customer satisfaction.",
      text:
        "ZEMI SWISS GmbH stands for reliability, quality and customer satisfaction. We provide professional transport and cleaning services to individuals, companies and administrations. Our goal: an effortless, punctual and spotless execution of every job.",
      stats: [
        { value: "100%", label: "Customer-focused" },
        { value: "24/7", label: "Reachable" },
        { value: "CH", label: "All Switzerland" },
      ],
    },
    services: {
      eyebrow: "Services",
      title: "Two disciplines. One standard: Swiss precision.",
      transport: {
        title: "Transport",
        description: "From furniture moves to business transport — fast, safe and on time across Switzerland.",
        items: ["Furniture moves", "Small transports", "Courier rides", "Delivery services", "Business transport"],
      },
      cleaning: {
        title: "Cleaning",
        description: "Brilliant results for homes and businesses — with handover-cleaning guarantee.",
        items: ["Apartment cleaning", "Move-out cleaning", "Office cleaning", "Maintenance cleaning", "Building cleaning"],
      },
    },
    why: {
      eyebrow: "Why ZEMI SWISS",
      title: "Five reasons why clients trust us.",
      items: [
        { title: "Reliable & punctual", desc: "Meeting deadlines is a matter of honour — the Swiss way." },
        { title: "Fair & transparent pricing", desc: "Clear quotes, no hidden costs." },
        { title: "Fast quotes", desc: "Reply within 24 hours — often the same day." },
        { title: "Personal customer service", desc: "Direct contact with the owner. No call centres." },
        { title: "Flexible scheduling", desc: "Weekends, evenings or short notice — we adapt to you." },
      ],
    },
    quote: {
      eyebrow: "Request a quote",
      title: "Your free quote in 60 seconds.",
      description: "Briefly describe your needs — we'll get back within 24 hours with a no-obligation offer.",
      fields: {
        name: "Name", phone: "Phone", email: "Email", service: "Service", message: "Message",
        servicePlaceholder: "Please choose",
        servicesOptions: { transport: "Transport", reinigung: "Cleaning", beides: "Transport & Cleaning", andere: "Other" },
        messagePlaceholder: "Tell us briefly what it's about…",
      },
      submit: "Request quote",
      submitting: "Sending…",
      success: "Thank you for your request. We'll get back to you as soon as possible.",
      error: "Sending failed. Please call us directly.",
      privacy: "By submitting you accept our privacy policy.",
    },
    contact: {
      eyebrow: "Contact", title: "Ready for the next job.",
      phone: "Phone", email: "Email", address: "Address",
      hours: "Opening hours", hoursValue: "Mon–Sat · 07:00–20:00",
      mapTitle: "Location Herisau",
    },
    footer: {
      tagline: "Transport & Cleaning",
      sections: { company: "Company", services: "Services", legal: "Legal" },
      links: { about: "About", contact: "Contact", quote: "Quote", imprint: "Imprint", privacy: "Privacy" },
      copyright: "© 2025 ZEMI SWISS GmbH · All rights reserved.",
    },
    legal: {
      imprint: { title: "Imprint", intro: "Information according to Swiss law.", sections: [
        { h: "Company", b: "ZEMI SWISS GmbH" },
        { h: "Address", b: "Langenlenstrasse 10b, 9100 Herisau, Switzerland" },
        { h: "Contact", b: "+41 78 321 52 49 · +41 78 258 42 61 · info@zemiswiss.ch" },
        { h: "Disclaimer", b: "Content was prepared with great care, but no warranty for accuracy is given." },
      ]},
      privacy: { title: "Privacy Policy", intro: "In accordance with Swiss data protection law (FADP).", sections: [
        { h: "Controller", b: "ZEMI SWISS GmbH, Langenlenstrasse 10b, 9100 Herisau, info@zemiswiss.ch" },
        { h: "Data collected", b: "When you submit our form we collect your name, phone, email and message — solely to process your request." },
        { h: "Third parties", b: "No transfer to third parties, except for the technical email delivery (Resend)." },
        { h: "Your rights", b: "You may request access, correction or deletion at any time. Contact: info@zemiswiss.ch." },
      ]},
      back: "Back to home",
    },
  },
};

export function getTranslation(lang) {
  return TRANSLATIONS[lang] || TRANSLATIONS.de;
}
